import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import ReactGA from 'react-ga';

const usePageLoad = () => {
    const { pathname, search } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
        ReactGA.set({
            page: pathname
        });
        ReactGA.pageview(pathname + search);
    }, [pathname, search]);

    return null;
};

export default usePageLoad;
